import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ModalActions = ({
  show,
  handleClose,
  action,
  title,
  bodyText,
  buttonText,
  branchName,
  loading
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{`${bodyText} "${branchName}".`}</p>
        <p> ¿Desea continuar?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>

        <Button
          variant="danger"
          onClick={loading ? () => {} : action}
          disabled={loading}
          className="d-flex justify-content-center align-items-center"
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            buttonText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ModalActions.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  action: PropTypes.func,
  title: PropTypes.string,
  bodyText: PropTypes.string,
  buttonText: PropTypes.string,
  branchName: PropTypes.string,
  loading: PropTypes.bool
};

export default ModalActions;
